import request from "@/util/request.js";
export const scanLog = (data) => request({
  url:`/wms/common/wcl/scanLog`,
  method:"POST",
  data
})